module.exports = __webpack_public_path__ + "img/bg-slide-3.c7df03ff.jpg";